export function toBool(value: unknown) {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        // The strings '1' and '0' read the same as the numbers 1 and 0.
        const normalized = value.trim().toLowerCase();
        return normalized === 'true' || normalized === '1';
    }
    return !!value;
}
